<template>
    <div class="options">
        <template v-for="(option, index) in options">
            <div :key="index" class="option" :id="'option_'+option.id">
                <div class="intro" @click="openOption(option.id)">
                    <img class="illusOpt" :src="'https://preprod.api.defipix.fr/ressource/reservation/image/'+option.picture">
                    <div class="preTitle">
                        <h4 class="nameOpt">{{ option.name }}</h4>
                        <template v-for="(booth, index) in listBooths(option.booth)">
                            <span class="nameBooth" :key="index" >{{ booth.name }}</span>
                        </template>
                    </div>
                </div>
                <img :id="'chevron_'+option.id" class="chevron" alt="ouvrir" src="https://preprod.api.defipix.fr/logos/chevron-down.png" @click="openOption(option.id)" />
                <div class="detail" :id="'detail_'+option.id">
                    <p class="descOpt" v-html=option.long_description />
                    <Gallery :imageArray="option.imageArray" :optionId="option.id" />
                </div>
            </div>
        </template>
    </div>
</template>

<script>

import JQuery from 'jquery';
let $ = JQuery;
import Gallery from './Gallery';

export default {
    data() {
        return {
            optionSelected: null,
        }
    },
    props: {
        options: Array,
        booths: Array,
    },
    updated: function () {
        this.openOption();
    },
    components: {
        Gallery,
    },
    methods: {        
        listBooths(list) {
            if (!list) return null;
            let result = [];
            list.forEach((element, index) => {
                this.booths.forEach((element2, index2) => {
                    if (element === element2.id) {
                        let booth = {
                            name: element2.name
                        }
                        result.push(booth);
                    }
                })
                
            });
            return result;
        },
        openOption(id) {
            id ? id = id : id = this.$route.query.id;
            if (id === this.optionSelected) {
                $("#detail_" + id).hide();
                $('#chevron_'+ id).animate({  transform: 0 }, {
                    step: function(now,fx) {
                        $(this).css({
                            '-webkit-transform':'rotate('+now+'deg)', 
                            '-moz-transform':'rotate('+now+'deg)',
                            'transform':'rotate('+now+'deg)'
                        });
                    }
                });
                this.optionSelected = null;
                return;
            }
            $("#detail_" + this.optionSelected).hide();
            $('#chevron_'+ this.optionSelected).animate({  transform: 0 }, {
                step: function(now,fx) {
                    $(this).css({
                        '-webkit-transform':'rotate('+now+'deg)', 
                        '-moz-transform':'rotate('+now+'deg)',
                        'transform':'rotate('+now+'deg)'
                    });
                }
            });
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#option_" + id).offset().top-100
            }, 1000);
            $('#chevron_'+id).animate({  transform: 180 }, {
                step: function(now,fx) {
                    $(this).css({
                        '-webkit-transform':'rotate('+now+'deg)', 
                        '-moz-transform':'rotate('+now+'deg)',
                        'transform':'rotate('+now+'deg)'
                    });
                }
            });
            $("#detail_" + id).css("display", "grid");
            this.optionSelected = parseInt(id);
        },
    }
}
</script>

<style scoped>

.options {
    display: grid;
    grid-template-columns: 100%;
    margin: auto;
}

.option {
    padding: 1em;
    margin: 1em auto;
    width: 100%;
    background-color: #25327B;
    box-shadow: 0px 0px 5px 0px #aaa;
    border-radius: 5px;
    position: relative;
}

.descOpt {
    color: #fff;
}

.intro {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.detail {
    display: none;
    padding: 2em 0 0 1em;
    grid-template-columns: 60% 40%;
}

.preTitle {
    margin: 0 0 0 1em;
}

.nameOpt {
    grid-area: title;
    color: #fff;
}

.nameBooth {
    padding: 0.3em;
    color: #fff;
    margin: 0.2em 0.5em 0 0;
    border: 1px solid #fff;
    border-radius: 10px;
    font-weight: bold;
}

.illusOpt {
    width: 4em;
}

.chevron {
    position: absolute;
    width: 1.5em;
    right: 1em;
    top: 1.5em;
}

.chevron:hover {
    cursor: pointer;
}

@media only screen and (max-width: 765px) {

    .detail {
        padding: unset;
        grid-template-columns: 100%;
    }
}

@media only screen and (max-width: 575px) {
    .nameOpt {
        max-width: 90%;
    }
}

@media only screen and (max-width: 450px) {
    .nameOpt {
        font-size: 18px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Options/List.vue